import React, { Component } from "react";
import { BrowserRouter as Router, Switch } from "react-router-dom";
import SeoRoute from "../common/SeoRoute";
import AuthenticatedRoute from "./AuthenticatedRoute.jsx";
import LoginComponent from "./LoginComponent.jsx";
import ListTodosComponent from "./ListTodosComponent.jsx";
import ErrorComponent from "./ErrorComponent.jsx";
import HeaderComponent from "./HeaderComponent.jsx";
import FooterComponent from "./FooterComponent.jsx";
import LogoutComponent from "./LogoutComponent.jsx";
import WelcomeComponent from "./WelcomeComponent.jsx";
import TodoComponent from "./TodoComponent.jsx";
import QnAJava from "../questionanswer/QnAJava.jsx";
import QnA from "../questionanswer/QnA.jsx";
import QnAReact from "../questionanswer/QnAReact.jsx";
import QnAKafka from "../questionanswer/QnAKafka.jsx";
import QnACassandra from "../questionanswer/QnACassandra.jsx";
import QnASQL from "../questionanswer/QnASQL.jsx";
import AddQuestion from "../questionanswer/AddQuestion.jsx";
import Projects from "../questionanswer/Projects.jsx";
import InterviewProcess from "../questionanswer/InterviewProcess.jsx";
import PrepareForInterview from "../questionanswer/PrepareForInterview.jsx";
import QnAPaginationAll from "../questionanswer/QnAPaginationAll.jsx";
import StreamAPIBlog from "../blogs/java/StreamAPIBlog.jsx";
import PrivacyPolicyMain from "../privacy/PrivacyPolicyMain.jsx";
import AddressBookPrivacyPolicy from "../privacy/AddressBookPrivacyPolicy.jsx";
import VocabularyAppPrivacyPolicy from "../privacy/VocabularyAppPrivacyPolicy.jsx";
import InterviewGuidePrivacyPolicy from "../privacy/InterviewGuidePrivacyPolicy.jsx";
import InterviewDojoPrivacyPolicy from "../privacy/InterviewDojoPrivacyPolicy.jsx";
import AboutUs from "../questionanswer/AboutUs.jsx";
import Learn from "../questionanswer/Learn.jsx";
import AmazonProducts from "../affiliates/AmazonProducts";
import WalmartProducts from "../affiliates/WalmartProducts";
import QnASpring from "../questionanswer/QnASpring.jsx";
import QnAHibernate from "../questionanswer/QnAHibernate.jsx";
import QnAJavaScript from "../questionanswer/QnAJavaScript.jsx";
import QnAJava8Features from "../questionanswer/QnAJava8Features.jsx";
import DesignPatterns from "../questionanswer/DesignPatterns.jsx";
import QnAAmazonWebServices from "../questionanswer/QnAAmazonWebServices.jsx";
import QnADataStructureAndAlgorithm from "../questionanswer/QnADataStructureAndAlgorithm.jsx";
import QnADocker from "../questionanswer/QnADocker.jsx";
import QnAKubernetes from "../questionanswer/QnAKubernetes.jsx";
import QnATerraform from "../questionanswer/QnATerraform.jsx";
import QnAAzure from "../questionanswer/QnAAzure.jsx";
import QnAAWS from "../questionanswer/QnAAmazonWebServices.jsx";
import QnAMongoDB from "../questionanswer/QnAMongoDB.jsx";
import QnAElasticSearch from "../questionanswer/QnAElasticSearch.jsx";
import QnAAngular from "../questionanswer/QnAAngular.jsx";
import QnABehavioral from "../questionanswer/QnABehavioral.jsx";
import QnAMicroservices from "../questionanswer/QnAMicroservices.jsx";
import QnArestAPI from "../questionanswer/QnArestAPI.jsx";
import QnASystemDesign from "../questionanswer/QnASystemDesign.jsx";
import QnACodingRound from "../questionanswer/QnACodingRound.jsx";
import SystemDesign from "../system-design/SystemDesign.jsx";
import SystemDesignDetail from "../system-design/SystemDesignDetail";
import InterviewGamePlanDetail from "../system-design/InterviewGamePlanDetail";
import PerformanceMathSizingDetail from "../system-design/PerformanceMathSizingDetail";
import InternetNetworkingFundamentalsDetail from "../system-design/InternetNetworkingFundamentalsDetail";
import StorageDatabasesDetail from "../system-design/StorageDatabasesDetail";
import CachingDetail from "../system-design/CachingDetail";
import MessagingStreamingDetail from "../system-design/MessagingStreamingDetail";
import DistributedSystemsTheoryDetail from "../system-design/DistributedSystemsTheoryDetail";
import ReliabilityResilienceDetail from "../system-design/ReliabilityResilienceDetail";
import ObservabilityOperationsDetail from "../system-design/ObservabilityOperationsDetail";
import ApisServiceDesignDetail from "../system-design/ApisServiceDesignDetail";
import SecurityPrivacyComplianceDetail from "../system-design/SecurityPrivacyComplianceDetail";
import ComputeRuntimeDetail from "../system-design/ComputeRuntimeDetail";
import AdvancedPatternsDetail from "../system-design/AdvancedPatternsDetail";
import TestingQualityDetail from "../system-design/TestingQualityDetail";
import CostEfficiencyDetail from "../system-design/CostEfficiencyDetail";
import QnABlind75 from "../questionanswer/QnABlind75.jsx";
import ConsulBlog from "../blogs/ConsulBlog.jsx";
import CDNBlog from "../blogs/CDNBlog.jsx";
import Algorithm from "../algorithms/Algorithm.jsx";
import QnASDLC from "../questionanswer/QnASDLC.jsx";
import GitBlog from "../blogs/GitBlog.jsx";
import LambdaStepFunctionBlog from "../blogs/LambdaStepFunctionBlog.jsx";
import AbilityTest from "../ability-test/AbilityTest.jsx";
import Blogs from "../blogs/Blogs.jsx";
import QnAServiceBus from "../questionanswer/QnAServiceBus.jsx";
import CacheBlog from "../blogs/CacheBlog.jsx";
import AndroidApp from "../privacy/AndroidApp.jsx";
import QnACosmos from "../questionanswer/QnACosmos.jsx";
import Quiz from "../ability-test/Quiz.jsx";
import QuizApp from "../ability-test/QuizApp.jsx";
import QnAJavalin from "../questionanswer/QnAJavalin.jsx";
import JsonSearch from "../questionanswer/search/JsonSearch.jsx";
import RabinProfile from "../profile/rabin";
import KhusbuProfile from "../profile/khusbu";
import QnAPython from "../questionanswer/QnAPython.jsx";
import JavaQuiz from "../abilityTest/JavaQuiz.jsx";
import JavaScriptQuiz from "../abilityTest/JavaScriptQuiz.jsx";
import SQLQuiz from "../abilityTest/SQLQuiz.jsx";
import CollectionAPIQuiz from "../abilityTest/CollectionAPIQuiz.jsx";
import SpringQuiz from "../abilityTest/SpringQuiz.jsx";
import HibernateQuiz from "../abilityTest/HibernateQuiz.jsx";
import ReactJS from "../abilityTest/ReactJS.jsx";
import Angular from "../abilityTest/Angular.jsx";
import Java8 from "../abilityTest/Java8.jsx";
import ContactUs from "../questionanswer/ContactUs.jsx";
import Badge from "../questionanswer/Badge.jsx"; 
import QnACSharp from "../questionanswer/QnACSharp.jsx";
import QnAArtificialIntelligence from "../questionanswer/QnAArtificialIntelligence.jsx";
import Career from "./Career";
import AboutTechVentureLLC from "./AboutTechVentureLLC.jsx";
import PythonQuiz from "../abilityTest/PythonQuiz.jsx";
import KafkaQuiz from "../abilityTest/KafkaQuiz.jsx";
import CassandraQuiz from "../abilityTest/CassandraQuiz.jsx";

class TodoApp extends Component {
  render() {
    return (
      <div className="TodoApp">
        <Router>
          <>
            <HeaderComponent />

            <Switch>
              <SeoRoute path="/" exact component={QnA} />
              <SeoRoute path="/login" component={LoginComponent} />
              <AuthenticatedRoute
                path="/welcome/:name"
                component={WelcomeComponent}
              />
              <AuthenticatedRoute path="/todos/:id" component={TodoComponent} />
              <AuthenticatedRoute
                path="/todos"
                component={ListTodosComponent}
              />
              <AuthenticatedRoute path="/logout" component={LogoutComponent} />
              <AuthenticatedRoute
                path="/addQuestion/:id"
                component={AddQuestion}
              />
              <SeoRoute path="/home" component={QnA} />
              <SeoRoute path="/questions" component={QnAJava} />
              <SeoRoute path="/java" component={QnAJava} />
              <SeoRoute path="/kafka" component={QnAKafka} />
              <SeoRoute path="/python" component={QnAPython} />
              <SeoRoute path="/cassandra" component={QnACassandra} />
              <SeoRoute path="/react" component={QnAReact} />
              <SeoRoute path="/sql" component={QnASQL} />
              <SeoRoute path="/spring" component={QnASpring} />
              <SeoRoute path="/cSharp" component={QnACSharp} />
              <SeoRoute path="/artificialIntelligence" component={QnAArtificialIntelligence} />
              
              <SeoRoute path="/hibernate" component={QnAHibernate} />
              <SeoRoute path="/javascript" component={QnAJavaScript} />
              <SeoRoute path="/java8features" component={QnAJava8Features} />
              <SeoRoute path="/designPatterns" component={DesignPatterns} />
              <SeoRoute path="/blind75" component={QnABlind75} />
              <SeoRoute path="/consul" component={ConsulBlog} />
              <SeoRoute path="/cdn" component={CDNBlog} />
              <SeoRoute path="/algorithms" component={Algorithm} />
              <SeoRoute path="/sdlc" component={QnASDLC} />
              <SeoRoute path="/git" component={GitBlog} />
              <SeoRoute path="/lambdaAndStepFunction" component={LambdaStepFunctionBlog} />
              <SeoRoute path="/proficiencyTest" component={AbilityTest} />
              <SeoRoute path="/blogs" component={Blogs} />
              <SeoRoute path="/serviceBus" component={QnAServiceBus} />
              <SeoRoute path="/cache" component={CacheBlog} />
              <SeoRoute path="/mobileApps" component={AndroidApp} />
              <SeoRoute path="/quiz" component={Quiz} />
              <SeoRoute path="/quizApp" component={QuizApp} />
              
              <SeoRoute path="/javaQuiz" component={JavaQuiz} />
              <SeoRoute path="/javascriptQuiz" component={JavaScriptQuiz} />
              <SeoRoute path="/sqlQuiz" component={SQLQuiz} />
              <SeoRoute path="/collectionApiQuiz" component={CollectionAPIQuiz} />
              <SeoRoute path="/springQuiz" component={SpringQuiz} />
              <SeoRoute path="/hibernateQuiz" component={HibernateQuiz} />
              <SeoRoute path="/reactJSQuiz" component={ReactJS} />
              <SeoRoute path="/angularQuiz" component={Angular} />
              <SeoRoute path="/java8Quiz" component={Java8} />

              <SeoRoute path="/pythonProficiencyTest" component={PythonQuiz} />
              <SeoRoute path="/kafkaProficiencyTest" component={KafkaQuiz} />
              <SeoRoute path="/cassandraProficiencyTest" component={CassandraQuiz} />
            

              <SeoRoute
                path="/amazonWebServices"
                component={QnAAmazonWebServices}
              />
              <SeoRoute path="/dsa" component={QnADataStructureAndAlgorithm} />
              <SeoRoute path="/kubernetes" component={QnAKubernetes} />
              <SeoRoute path="/docker" component={QnADocker} />
              <SeoRoute path="/terraform" component={QnATerraform} />
              <SeoRoute path="/azure" component={QnAAzure} />
              <SeoRoute path="/aws" component={QnAAWS} />
              <SeoRoute path="/mongoDB" component={QnAMongoDB} />
              <SeoRoute path="/elasticSearch" component={QnAElasticSearch} />
              <SeoRoute path="/angular" component={QnAAngular} />
              <SeoRoute path="/microservices" component={QnAMicroservices} />
              <SeoRoute path="/behavioral" component={QnABehavioral} />
              <SeoRoute path="/restAPI" component={QnArestAPI} />
              <SeoRoute path="/systemDesignInterviewQuestions" component={QnASystemDesign} />
              <SeoRoute path="/codingRound" component={QnACodingRound} />

                {/* specific pages FIRST */}
                <SeoRoute
                  exact
                  path="/interview-game-plan"
                  component={InterviewGamePlanDetail}
                />

                {/* list page */}
                <SeoRoute exact path="/systemDesign" component={SystemDesign} />

                {/* generic catch-all LAST */}
                <SeoRoute path="/systemDesign/:slug" component={SystemDesignDetail} />

               <SeoRoute exact path="/performance-math-and-sizing" component={PerformanceMathSizingDetail} />

               <SeoRoute exact path="/internet-and-networking-fundamentals" component={InternetNetworkingFundamentalsDetail} />

              <SeoRoute exact path="/storage-and-databases" component={StorageDatabasesDetail} />

              <SeoRoute exact path="/caching" component={CachingDetail} />

              <SeoRoute exact path="/messaging-and-streaming" component={MessagingStreamingDetail} />

              <SeoRoute exact path="/distributed-systems-theory" component={DistributedSystemsTheoryDetail} />

              <SeoRoute exact path="/reliability-and-resilience" component={ReliabilityResilienceDetail} />

              <SeoRoute exact path="/observability-and-operations" component={ObservabilityOperationsDetail} />

              <SeoRoute exact path="/apis-and-service-design" component={ApisServiceDesignDetail} />

              <SeoRoute exact path="/security-privacy-compliance" component={SecurityPrivacyComplianceDetail} />

              <SeoRoute exact path="/compute-and-runtime" component={ComputeRuntimeDetail} />

              <SeoRoute exact path="/advanced-patterns" component={AdvancedPatternsDetail} />

              <SeoRoute exact path="/testing-and-quality-at-scale" component={TestingQualityDetail} />

              <SeoRoute exact path="/cost-and-efficiency" component={CostEfficiencyDetail} />

              <SeoRoute path="/cosmos" component={QnACosmos} />
              <SeoRoute path="/javalin" component={QnAJavalin} />
              {/* <SeoRoute path="/selenium" component={QnASelenium} /> */}
              <SeoRoute path="/projects" component={Projects} />
              <SeoRoute path="/interviewProcess" component={InterviewProcess} />
              <SeoRoute path="/all" component={QnAPaginationAll} />
              <SeoRoute path="/privacyPolicyMain" component={PrivacyPolicyMain} />
              <SeoRoute path="/aboutTechVentureLLC" component={AboutUs} />
              <SeoRoute path="/aboutUs" component={AboutTechVentureLLC} />
              <SeoRoute path="/contactUs" exact component={ContactUs} />
              <SeoRoute path="/badges" exact component={Badge} />
              <SeoRoute path="/search" component={JsonSearch} />
              <SeoRoute exact path="/profile/rabin-pantha" component={RabinProfile} />
              <SeoRoute exact path="/profile/khusbu-thapa" component={KhusbuProfile} />
              <SeoRoute path="/learn" component={Learn} />
              <SeoRoute path="/career" component={Career} />
              <SeoRoute
                path="/addressBookPrivacyPolicy"
                component={AddressBookPrivacyPolicy}
              />
              <SeoRoute
                path="/vocabularyAppPrivacyPolicy"
                component={VocabularyAppPrivacyPolicy}
              />
              <SeoRoute
                path="/interviewDojoApp"
                component={InterviewGuidePrivacyPolicy}
              />
              <SeoRoute
                path="/interviewDojoPrivacyPolicy"
                component={InterviewDojoPrivacyPolicy}
              />
              <SeoRoute path="/blog/java/streamAPI" component={StreamAPIBlog} />
              <SeoRoute
                path="/prepareForInterview"
                component={PrepareForInterview}
              />
              <SeoRoute path="/amazonProducts" component={AmazonProducts} />
              <SeoRoute path="/walmartProducts" component={WalmartProducts} />
              <SeoRoute component={ErrorComponent} />
            </Switch>
            <FooterComponent />
          </>
        </Router>
        {/*<LoginComponent/>
                <WelcomeComponent/>*/}
      </div>
    );
  }
}

export default TodoApp;
